import type { AttributeFilters } from '../attributeFilters';
import type { TableResponseBody } from '../table/Table';
import type { Branded } from '../types/Branded';

export type AttributeScopeBase = {
  attributeFilters: AttributeFilters;
};

export type AttributeScopeId = Branded<string, 'AttributeScopeId'>;

export type AttributeScope = AttributeScopeBase & {
  id: AttributeScopeId;
};

export type AttributeScopesGetResponseBody = TableResponseBody<AttributeScope>;
